import { injectable, inject } from 'inversify';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { UpdateInteractionResultTrackingCommand, UpdateInteractionResultTrackingCommandPayload } from '../api';
import { InteractionSuspendDataStore2 } from '../common';

@injectable()
export class Scorm2004UpdateInteractionResultCommandHandler implements CommandHandler<UpdateInteractionResultTrackingCommand> {

  constructor(
    @inject(InteractionSuspendDataStore2)
    private suspendDataStore: InteractionSuspendDataStore2,
) {
  }

  public async execute(command: UpdateInteractionResultTrackingCommandPayload) {

    await this.suspendDataStore.execute(
      createCommand<UpdateInteractionResultTrackingCommand>('update-interaction-result', command))
  }
}
